import { ResourceProps } from '@refinedev/core';
import { roleAccess, rolePriority } from '../config/roleAccess';

/**
 * Фільтрує ресурси по ролях, з урахуванням пріоритету ролей
 * @param user - обʼєкт користувача з масивом ролей
 * @param resources - локалізовані ресурси з useLocalizedResources()
 */
export const getFilteredResourcesByUser = (
    user: { roles: string[] } | null,
    resources: ResourceProps[]
): ResourceProps[] => {
    if (!user || !user.roles?.length) return [];

    const getHighestPriorityRole = (roles: string[]): string | null => {
        let chosen: string | null = null;
        let maxPriority = -Infinity;

        roles.forEach(role => {
            const priority = rolePriority[role] ?? 0;
            if (priority > maxPriority) {
                maxPriority = priority;
                chosen = role;
            }
        });

        return chosen;
    };

    const topRole = getHighestPriorityRole(user.roles);
    // @ts-ignore
    const allowed = roleAccess[topRole ?? ''] ?? [];

    return resources.filter(r => allowed.includes(r.name));
};
